<template>
  <div id="app" :class="{'big':bigfont}">
    <Top :menu="headermenu"></Top>
    <!--Connection: <span v-if="online">online</span><span v-if="!online">offline</span>-->

    <div class="head" :class="{'active':scrollPosition>30}">
      <div class="headline">
        <h1 class="inherit" v-if="page">
          <transition name="delayfade">
                    <span v-if="page.acf">
                        <span v-if="team&&view==='teams'" v-html="'Teamberichte - '+team.title.rendered"
                              key="1">  </span>
                        <span v-else-if="dog&&view==='hunde'" key="3">
                            <span v-if="dog.title" v-html="'Assistenzhunde - '+dog.title.rendered"></span>
                        </span>
                        <span v-else-if="page.acf.uberschrift" v-html="page.acf.uberschrift" key="2"></span>
                        <span v-else v-html="page.title.rendered" key="4"></span>
                    </span>
          </transition>
        </h1>
        <a class="ati" target="_blank" href="https://www.assistancedogsinternational.org/">

        <img src="@/assets/ADI-accredited-logo_weiss.png" alt="">
        </a>
      </div>
      <div class="headline" v-if="dog" style="padding-top: 0;">
        <Extranav v-if="dog.acf&&view==='hunde'" :blocks="dog.acf.layout"></Extranav>
      </div>
      <div class="headline" v-if="page" style="padding-top: 0;">
        <Extranav v-if="page.acf&&view==='seite'" :blocks="page.acf.layout"></Extranav>
      </div>
    </div>
    <div class='wrap'>
      <div v-if="offline">
        <div class="alert alert-danger" role="alert">
          <strong>Achtung!</strong> Ihre Internet-Verbindung ist unterbrochen!
        </div>
      </div>
      <transition-group name='delayfade' mode="out-in">
        <div class="content" :key="sitechange">
          <Start v-if="view==='start'" :page="page"></Start>
          <Hunde v-if="view==='hunde'"></Hunde>
          <Teams v-if="view==='teams'"></Teams>
          <Seite v-if="view==='seite'" :page="page"></Seite>
          <News v-if="view==='news'" :page="page"></News>
        </div>
      </transition-group>
      <div class="content">
        <Help v-if="view==='helfen'"></Help>
      </div>
      <transition-group name='latefade' mode="out-in" appear>
        <div :key="sitechange">
          <Sponsoren :page="page" :key="" v-if="view!=='helfen'"></Sponsoren>
        </div>
        <footer :key="sitechange">
          <Foot :menu="footermenu">
          </Foot>
        </footer>
      </transition-group>
    </div>
  </div>
</template>
<script>

import store from '@/store'
import Vuex from 'vuex'

export default {
  store,
  name: 'app',

  components: {
    Top: () => import('@/components/parts/Header'),
    Foot: () => import('@/components/parts/Footer'),
    Start: () => import('@/components/pages/Start'),
    Hunde: () => import('@/components/pages/Hunde'),
    Teams: () => import('@/components/pages/Teams'),
    Seite: () => import('@/components/pages/Seite'),
    News: () => import('@/components/pages/News'),
    Help: () => import('@/components/pages/Help'),
    Sponsoren: () => import('@/components/parts/Sponsoren'),
    Extranav: () => import('@/components/parts/Extranav'),

  },
  created: function () {
    this.getPage()
    if (!(store.state.dogs.length > 0)) store.dispatch('getDogs');
    if (!(store.state.footermenu.length > 0)) store.dispatch('getFootermenu');
    if (!(store.state.headermenu.length > 0)) store.dispatch('getHeadermenu');
    if (!(store.state.teams.length > 0)) store.dispatch('getTeams');
    if (!(store.state.sponsors.length > 0)) store.dispatch('getSponsors');

  },
  methods: {
    getPage: function () {
      switch (this.view) {

        case 'start':
          store.dispatch('getPageBySlug', 'start');
          break;

        case 'seite':
          store.dispatch('getPageBySlug', this.slug);
          break;
        case 'hunde':

          store.dispatch('getPageBySlug', 'assistenzhunde');
          break;
        default:
          if (store.state.page.slug !== this.$route.meta.view) {
            store.dispatch('getPageBySlug', this.$route.meta.view);
          }
      }
    },
    getLogoPos: function () {
      let pos = (this.scrollPosition * -2) - 60;
      return pos + 'px'
    }
  },
  computed: Vuex.mapState({
    page: 'page',
    dog: 'dog',
    team() {
      let team = store.state.teams.filter(d => d.slug === this.$route.params.slug)
      this.index = store.state.teams.indexOf(team[0])
      return team[0]
    },
    bigfont: 'bigfont',
    sitechange() {
      if (this.$route.meta.view === 'helfen') return 'help'
      else if (this.$route.params.slug) return this.$route.params.slug;
      else return this.$route.name
    },
    slug() {
      return this.$route.params.slug
    },
    footermenu() {
      return store.state.footermenu;
    },
    headermenu() {
      return store.state.headermenu;
    },
    view() {
      return this.$route.meta.view;
    },
    rname() {
      return this.$route.meta.rname;
    },
    online() {
      return VueOnline.isOnline
    },
    title() {
      let rawtitle = store.state.page._aioseop_title ? store.state.page._aioseop_title : (store.state.page.title ? store.state.page.title.rendered : '')

      return rawtitle == undefined ? '' : this.htmlEncode(rawtitle)

    },
    description() {
      if (store.state.page.meta) {
        return store.state.page.meta['_aioseop_description'] ? store.state.page.meta._aioseop_description[0] : ''
      }

    }
  }),
  watch: {
    // bigfont() {
    //     this.bigfont ? jQuery('#app').addClass('big') : jQuery('#app').css('font-size', '16px')
    // },
    $route() {
      this.getPage()
    },
    // dogs() {
    //     store.commit('getDog', this.$route.params.slug)
    // },
    slug() {
      store.commit('getDog', this.$route.params.slug)
    },

  },
  metaInfo() {
    return {
      title: this.title ? (this.title === undefined ? '' : this.title) : '',

      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} - Partnerhunde Österreich` : 'Partnerhunde Österreich';
      },
      meta: [
        {charset: 'utf-8'},
        {vmid: "description", name: 'description', content: this.description},
        {vmid: "author", name: 'author', content: 'Partner Hunde Österreich'}
      ],
      link: [

        {rel: 'favicon', href: '/favicon.png'}
      ]

    }
  },

}

</script>

<style lang="scss" type="text/scss" scoped>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  overflow-x: hidden;
  color: #444;
  position: relative;
  top: 0;
  font-size: 16px;
  @include tablet {
    font-size: 14px;
    line-height: 1.3em;
  }
  line-height: 1.4em;

  &.big {
    font-size: 22px;
    line-height: 1.4em;
    @include tablet {
      font-size: 18px;
      line-height: 1.3em;
    }
  }

  .wrap {
    padding-top: 105px;
    @include tablet {
      padding-top: 100px;
    }
    position: relative;
    top: 0;
    z-index: 0;
  }

  .head {
    top: 50px;
    min-height: 50px;
    z-index: 300;
    position: fixed;

    width: 100%;
    border-bottom: 1px #ccc solid;
    text-align: left;
    /*margin-bottom: 60px;*/
    /*display: flex;*/
    align-items: center;
    background: $bluegradient;
    transition: all 0.2s ease;

    &.active {
      min-height: 30px;
      .ati {
        height: 1.3em;

        @include phone {
          display: none;
        }
      }
      h1 {
        font-size: 1em;
        @include mobile {
          font-size: 0.8em;
          height: 1.6em;
        }
      }

      .headline {
        margin-left: 160px;
        @include tablet {
          margin-left: 70px;
        }
        @include mobile {
          margin-left: 0px;
        }
      }
    }

  }
}

h2 {
  font-weight: 300;
}

.headline {
  padding: 10px 15px 0;
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-left: 160px;
  @include tablet {
    margin-left: 10px;
  }

  .ati {
    height: 2.5em;
    //margin-right: 50px;
    padding-right: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      height: 90%;
    }
    @include phone {
      display: none;
    }
  }
}

.smalllogo {
  border-bottom: 1px solid $blue;
  /*border-image: linear-gradient(to right, #1e72ae 0%, #4aa4d0 100%);*/
  /*border-image-slice: 1;*/

  transform: translateY(-100%);
  transition: transform 0s linear;

  &.active {
    /*margin-left:0;*/
    /*.logo {*/
    transition: transform 0.2s linear;
    width: auto;
    transform: translateY(0);
    /*}*/

  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue